import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Header } from '@ampdx/component-library/dist/components/'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../shared/utils/common-utils'
import { reactToCwp } from '../../../common/react-utils'
import './header.css'
import { cacheGet, refreshDataVersion } from '@ampdx/component-library/src/utils'

const HeaderMicrosite = props => {
  const { menuName, isMenuLess, layout, header } = props.content
  const [windowWidth, setWindowWidth] = useState(0)
  const [mainMenu, setMainMenu] = useState({})
  const env = getCWPEnvironmentForURL(window.location.href)
  useEffect(() => {
    const handleWindowSizeChange = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleWindowSizeChange)
    setWindowWidth(window.innerWidth)
    async function fetchCacheVersion() {
      if (window.innerWidth < 1025)
        await refreshDataVersion(
          `${APIENDPOINT(env).base}halapi/resourcebundles/ampmicrosites.cacheversion`
        )
    }
    fetchCacheVersion()
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])
  useEffect(() => {
    async function fetchMenu() {
      const micrositeMenuUrl = `${APIENDPOINT(env).menuBaseWithParams}${menuName}`
      let mainMenu = await cacheGet(windowWidth < 1025 && !isMenuLess ? micrositeMenuUrl : '')

      setMainMenu(mainMenu)
    }
    fetchMenu()
  }, [windowWidth])

  return (
    <Header
      headerDocument={header ?? null}
      mainMenu={mainMenu}
      backgroundColor={'u-bgColorWhite'}
      textColor={'u-textColorActionBlue'}
      menuIconColor={'u-bgColorActionBlue'}
      layoutClass={layout}
    />
  )
}

HeaderMicrosite.propTypes = {
  content: PropTypes.shape({
    menuName: PropTypes.string.isRequired,
    isMenuLess: PropTypes.string.isRequired,
    layout: PropTypes.string.isRequired,
    header: PropTypes.object,
  }),
}

export default reactToCwp(HeaderMicrosite)
